package co.maytes.standupbot.dashboard.features.standups

import co.maytes.standupbot.shared.dto.standup.UpdateStandupRequestDto
import co.maytes.standupbot.shared.validation.MeetingUrlValidator
import co.maytes.standupbot.shared.validation.ValidationResult

object MeetingLinkForm {
    const val PLACEHOLDER = "https://meet.google.com/abc-defg-hij"
    const val HINT = "Shown as “Join the call ↗” at the bottom of each post. Only https links; the bot never opens it."

    fun error(draft: String): String? =
        MeetingUrlValidator.normalize(draft)?.let { (MeetingUrlValidator.validate(it) as? ValidationResult.Error)?.message }

    fun isDirty(
        draft: String,
        saved: String?,
    ): Boolean = MeetingUrlValidator.normalize(draft) != saved

    fun canSave(
        draft: String,
        saved: String?,
    ): Boolean = isDirty(draft, saved) && error(draft) == null

    fun request(draft: String): UpdateStandupRequestDto =
        MeetingUrlValidator.normalize(draft)
            ?.let { UpdateStandupRequestDto(meetingUrl = it) }
            ?: UpdateStandupRequestDto(clearMeetingUrl = true)
}
